import _ from 'underscore';
import { Component } from 'react';
import styled from 'styled-components';
import { media, theme } from '../../../styles';

export default class SearchBar extends Component {
  TRANSLATED_ADVANCED_SEARCH = I18n.t('js.learner.search.advanced');

  constructor(props) {
    super(props);

    this.state = {
      query: this.props.query || '',
      inUse: false,
    };
    this.throttledSearch = _.debounce(
      this.handleSearch.bind(this),
      this.props.debouncedSearchTime || APP_CONSTANTS.DEBOUNCED_SEARCH_TIME.NORMAL,
    );
  }

  componentDidMount() {
    if (this.props.controlledQuery) this.throttledSearch();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.query !== this.props.query) {
      this.setState({ query: this.props.query }, () => {
        this.throttledSearch();
      });
    }
  }

  render() {
    const { onFocus, onKeyDown, allowReset, controlledQuery, searchWithinUniversity, showAdvancedSearchOption } =
      this.props;

    const query = controlledQuery === undefined ? this.state.query : controlledQuery;

    if (this.props.iconWhenUnused && !this.state.inUse) {
      return this.getIcon();
    }

    let wrapperCls = showAdvancedSearchOption ? 'search-bar--with-advanced-option' : '';

    if (searchWithinUniversity) wrapperCls += ' search-bar--within-university';

    return (
      <div className={`search-bar ${wrapperCls}`} onClick={this.props.showDropdown}>
        <input
          id="search-input"
          aria-label="Search"
          data-testid="search-input"
          onBlur={this.onBlur}
          onChange={this.handleChange}
          onFocus={onFocus}
          onKeyDown={onKeyDown}
          placeholder={this.props.placeholder}
          ref={(search) => (this.search = search)}
          type="text"
          value={query}
          {...this.props.accessibilityProps}
        />
        {showAdvancedSearchOption && this.renderAdvancedSearchOption()}
        {allowReset && (
          <img
            className="search-bar--clear"
            src="/images/cross_icon_grey.svg"
            onClick={this.resetSearch.bind(this, true)}
          />
        )}
      </div>
    );
  }

  renderAdvancedSearchOption = () => (
    <AdvancedSearchBtn onClick={this.handleAdvancedSearchOptionClick}>
      {this.TRANSLATED_ADVANCED_SEARCH}
    </AdvancedSearchBtn>
  );

  handleAdvancedSearchOptionClick = () => {
    const queryParam = this.props.controlledQuery ? `?query=${this.props.controlledQuery}` : '';
    window.location = `/advanced_search/${queryParam}`;
  };

  onBlur = (e) => {
    this.setState({ inUse: false });
    this.props.onBlur ? this.props.onBlur(e) : null;
  };

  handleChange = () => {
    const updatedQuery = $(this.search).val();
    if (this.props.updateControlledQuery) {
      this.props.updateControlledQuery(updatedQuery);
    } else {
      this.setState({ query: updatedQuery });
    }

    if (this.props.clearActive) this.props.clearActive();
    this.throttledSearch();
  };

  getIcon() {
    return (
      <div className="search-bar-hidden-icon">
        <img
          data-testid="search-icon"
          src="/images/search_icon_outlined.svg"
          width="26px"
          height="30px"
          style={{ paddingRight: 2 }}
          onClick={() => this.showSearchInput()}
        />
      </div>
    );
  }

  showSearchInput() {
    this.setState({ inUse: true }, () => {
      this.search.focus();
    });
  }

  handleSearch() {
    let query = this.props.controlledQuery || this.state.query;

    if (query) {
      query = query.trim();
      if (!this.props.normalizeCase) query = query.toLowerCase();
      this.props.search(query);
    } else {
      this.resetSearch(false);
    }
  }

  resetSearch = (fullReset) => {
    if (fullReset) {
      const { onReset } = this.props;
      this.setState({ inUse: false });
      if (typeof onReset === 'function') onReset();
    }

    if (this.props.updateControlledQuery) {
      this.props.updateControlledQuery('');
    } else {
      this.setState({ query: '' });
    }

    this.props.search(null);
  };
}

const AdvancedSearchBtn = styled.div`
  cursor: pointer;
  color: ${theme.color.placeholder};
  font-size: 0.65rem;
  margin-top: 2px;
  margin-right: 25px;
  display: flex;
  align-items: center;
  letter-spacing: 0.3px;
  position: relative;
  min-width: 25px;

  ${media.mobile} {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 5px;
    margin-top: 0px;
  }

  &:hover {
    ${theme.font.semibold}
    color: #2B313F;
  }
`;

SearchBar.defaultProps = { placeholder: 'Search...', normalizeCase: false, allowReset: false };
